(ns app.front.view.profile.bluebeam
  (:require [re-frame.core-instrumented :as rf]))

(rf/reg-event-db ::bluebeam-integration-data.success
  (fn [db [_ _ data]]
    (-> db
        (assoc ::bluebeam-integration-data data)
        (assoc-in [:session/user :user/bluebeam-integration?] (:integration-enabled? data)))))

(rf/reg-sub ::bluebeam-integration-data :-> ::bluebeam-integration-data)

(rf/reg-event-fx ::toggle-bluebeam-integration
  (fn [_ [_ enabled?]]
    {:dispatch [:comm/command-monitored
                {:command    :user/set-bluebeam-integration
                 :method     :post
                 :data       {:enabled? enabled?}
                 :on-success [::bluebeam-integration-data.success]}]}))

(rf/reg-event-fx ::bluebeam-authentication.success
  (fn [_ [_ _ {:keys [redirect-url]}]]
    (if redirect-url
      {:navigate-to redirect-url}
      {:dispatch [::fetch-integration-data]})))

(rf/reg-event-fx ::bluebeam-authentication
  (fn [_ _]
    {:dispatch [:comm/command-monitored
                {:command    :user/set-bluebeam-authentication
                 :method     :post
                 :on-success [::bluebeam-authentication.success]}]}))

(rf/reg-event-fx ::fetch-integration-data
  (fn [_ _]
    {:dispatch [:comm/command-monitored
                {:command    :user/get-bluebeam-integration-data
                 :method     :get
                 :on-success [::bluebeam-integration-data.success]}]}))
